import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { BrandPopup } from '..';

interface POIHoverPopupProps {
    brand: any;
    selectedBrands: any[];
    focusedPoi?: any;
    roi: { north: number; south: number; east: number; west: number; } | null;
    onClose: (e: any) => void;
    onNavigate: (e: any, geoLevel: string, geoId: any, geoLevelName: string) => void;
    carousel?: {
        type: string;
        markers: any[];
        currentIndex: number;
        uniqueKeyField: string;
    } | null;
    onCarouselNext?: () => void;
    onCarouselPrev?: () => void;
}

/**
 * POIHoverPopup - Displays hover popup for Point of Interest (POI) markers
 * Supports carousel navigation when multiple POIs are colliding
 */
export const POIHoverPopup: React.FC<POIHoverPopupProps> = ({
    brand,
    selectedBrands,
    focusedPoi,
    roi,
    onClose,
    onNavigate,
    carousel,
    onCarouselNext,
    onCarouselPrev,
}) => {
    if (!brand) return null;

    return (
        <AdvancedMarker
            key={brand.branchId}
            position={{
                lat: brand.latitude,
                lng: brand.longitude
            }}
            zIndex={200}
        >
            <BrandPopup
                brand={brand}
                selBrands={selectedBrands}
                focusedPoi={focusedPoi}
                handleClose={onClose}
                handleNavigation={onNavigate}
                roi={roi}
                carousel={carousel}
                onCarouselNext={onCarouselNext}
                onCarouselPrev={onCarouselPrev}
            />
        </AdvancedMarker>
    );
};
